export const voucherPaths = {
  VOUCHER: "",
  VOUCHER_MOVEMENT: "movement",
  VOUCHER_CREATE: "create",
  VOUCHER_EDIT: ":id",
  VOUCHER_ID: (id) => `${id}`,
};
